/**
 * Takes in a set of items and splits it into display items/overflow items if
 * the number of items exceeds the maximum amount of displayed items.
 * @param items items to split
 * @param maxDisplayedItems the maximum numbers of items to display before overflowing
 */
export default function splitDisplayedItems<T>(items: T[], maxDisplayedItems: number = 8) {
    if (items.length <= maxDisplayedItems) {
        return {
            displayItems: items,
            overflowItems: [],
        };
    }

    return {
        displayItems: items.slice(0, maxDisplayedItems - 1),
        overflowItems: items.slice(maxDisplayedItems - 1),
    };
}
